const initalState = null

const docSubSearchPropertyReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_DOCUMENT_SUBMISSION_SEARCH_PROPERTY":
			return data
		
		default:
			return state
	}
}

const selectedSubmissionSeqReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "SELECTED_SUBMISSION_SEQ":
			return data
		
		default:
			return state
	}
}


const submissionDetailReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_SUBMISSION_VALUE":
			return data
		
		default:
			return state
	}
}

const modifySubmissionValueReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "MODIFY_SUBMISSION_VALUE":
			return data
		
		default:
			return state
	}
}


const documentSubmissionTypeReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_DOCUMENT_SUBMISSION_TYPE":
			return data
		
		default:
			return state
	}
}

const documentSubmissionFormFieldReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_DOCUMENT_SUBMISSION_FORM_FIELD":
			return data
		
		default:
			return state
	}
}

const documentSubmissionCreateValueReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_DOCUMENT_SUBMISSION_CREATE_VALUE":
			return data
		
		default:
			return state
	}
}


export {
	docSubSearchPropertyReducer,
	selectedSubmissionSeqReducer,
	submissionDetailReducer,
	modifySubmissionValueReducer,
	documentSubmissionTypeReducer,
	documentSubmissionFormFieldReducer,
	documentSubmissionCreateValueReducer
}